

















import { defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { isTipMessageDetails, TipMessageDetails } from "@scrile/api-provider/dist/api/TipProvider";
import { formatDate } from "@/lib/time";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney/FormatMoney.vue";
import MessageItemLink from "../components/MessageItemLink";

export default defineComponent({
  name: "SystemMessageTip",
  inheritAttrs: false,
  components: { FormatMoney, BaseIcon, MessageItemLink },
  props: {
    message: { type: Object as () => Message, required: true },
    authUserId: { type: String, required: true },
  },
  computed: {
    details(): TipMessageDetails | null {
      return isTipMessageDetails(this.message.details) ? this.message.details : null;
    },
    hoursMinutes(): string {
      return formatDate(new Date(this.message.time), { hour: "2-digit", minute: "2-digit", hour12: false });
    },
    opponentMessage(): boolean {
      return this.message.senderUser?.id !== this.authUserId;
    },
  },
  mounted() {
    this.$emit("rendered", { el: this.$el });
  },
});
